/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import { List } from 'immutable'
import AppDispatcher from '../../core/AppDispatcher'
import PrefectureOptionState from './state/PrefectureOptionState'
import CheckInEvent from '../../event/CheckInEvent'

class PrefectureOptionsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List([])
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case CheckInEvent.fetchOne:
        const prefectures = payload.prefectures.map(prefecture => {
          return new PrefectureOptionState().mergeModel(prefecture)
        })
        return List(prefectures)

      default:
        return state
    }
  }
}

export default new PrefectureOptionsStore()
